<div *ngIf="isUpdating" class="loader-wrapper">
	<app-spinner></app-spinner>
</div>
<form [hidden]="isUpdating" class="notification-form" [formGroup]="form" (ngSubmit)="onSubmit()">
	<!-- Notification name control -->
	<mat-form-field appearance="outline">
		<mat-label>Name:</mat-label>
		<input
			matInput
			type="text"
			formControlName="name"
			placeholder="Provide notification setting name"
			autocomplete="off"
		/>
		<mat-error *ngIf="formNameControl.touched && formNameControl.errors && formNameControl.errors.required"
			>Field is required
		</mat-error>
		<mat-error *ngIf="formNameControl.touched && formNameControl.errors && formNameControl.errors.duplicateName"
			>The notification setting name must be unique
		</mat-error>
	</mat-form-field>
	<!-- Notification accordion -->
	<mat-accordion>
		<!-- Subscriptions -->
		<mat-expansion-panel formGroupName="subscriptions" togglePosition="before">
			<mat-expansion-panel-header>
				<mat-panel-title>Topics</mat-panel-title>
			</mat-expansion-panel-header>
			<!-- Zesty Disk -->
			<mat-expansion-panel formGroupName="zesty_disk" togglePosition="before">
				<mat-expansion-panel-header>
					<mat-panel-title>Zesty Disk</mat-panel-title>
				</mat-expansion-panel-header>
				<!-- Critical -->
				<mat-expansion-panel formGroupName="critical" togglePosition="before">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<mat-checkbox
								color="primary"
								formControlName="checked"
								[indeterminate]="descendantsPartiallySelected(FORM_CONTROL_IDS.zestyCritical)"
								(change)="handleCheckSubForms($event, FORM_CONTROL_IDS.zestyCritical)"
								(click)="$event.stopPropagation()"
							>
								Critical
							</mat-checkbox>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<!-- Zesty Disk Failures -->
					<div formGroupName="zesty_disk_resize_failures" class="d-flex align-center flex-wrap pb-3 ml-4">
						<div class="d-flex align-items-baseline">
							<mat-checkbox
								color="primary"
								formControlName="subscribed"
								(change)="toggleParent($event, FORM_CONTROL_IDS.zestyCritical)"
							>
								Resize Failures
							</mat-checkbox>
							<button
								class="info-icon-color"
								type="button"
								mat-icon-button
								appInfoTooltip="You will be notified when the filesystem resizing fails"
								aria-label="Example icon button with a vertical three dot icon"
							>
								<mat-icon>error</mat-icon>
							</button>
						</div>
					</div>
					<div formGroupName="zesty_disk_agent_stop_reporting" class="d-flex align-items-baseline flex-wrap pb-3 ml-4">
						<div class="line d-flex flex-wrap align-items-baseline pb-2">
							<mat-checkbox
								class="mr-2"
								color="primary"
								formControlName="subscribed"
								(change)="toggleParent($event, FORM_CONTROL_IDS.zestyCritical, 'zesty_disk_agent_stop_reporting')"
							>
							</mat-checkbox>
							<div>
								<div class="line d-flex flex-wrap align-items-baseline pb-2">
									<span>Zesty Disk Collector has stopped reporting</span>
									<button
										class="info-icon-color"
										type="button"
										mat-icon-button
										appInfoTooltip="A notification will be sent if Zesty Disk Collector has stopped reporting."
										aria-label="Example icon button with a vertical three dot icon"
									>
										<mat-icon>error</mat-icon>
									</button>
								</div>
							</div>
						</div>
						<!-- Zesty Disk Low free space on FS -->
						<div
							*ngIf="false"
							formGroupName="zesty_disk_filesystem_free_space"
							class="d-flex align-items-baseline flex-wrap pb-3"
						>
							<mat-checkbox
								class="mr-2"
								color="primary"
								formControlName="subscribed"
								(change)="toggleParent($event, FORM_CONTROL_IDS.zestyCritical, 'zesty_disk_filesystem_free_space')"
							>
							</mat-checkbox>
							<span>Low Free Space on filesystem</span>
							<div class="form__error-wrapper">
								<input formControlName="threshold" class="form-control w100p ml-1 mr-2" type="number" />
								<span *ngIf="getFormError(FORM_CONTROL_IDS.lowFreeSpaceThreshold).hasError('min')" class="form__error">
									should be between greater than 0
								</span>
								<span
									*ngIf="getFormError(FORM_CONTROL_IDS.lowFreeSpaceThreshold)?.hasError('required')"
									class="form__error"
									>field is <strong>required</strong></span
								>
							</div>
							GB
						</div>
					</div>
				</mat-expansion-panel>
				<!-- Info -->
				<mat-expansion-panel formGroupName="info" togglePosition="before">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<mat-checkbox
								color="primary"
								formControlName="checked"
								[indeterminate]="descendantsPartiallySelected(FORM_CONTROL_IDS.zestyInfo)"
								(change)="handleCheckSubForms($event, FORM_CONTROL_IDS.zestyInfo)"
								(click)="$event.stopPropagation()"
							>
								Info
							</mat-checkbox>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<!-- Zesty Disk Monitored fs utilization -->
					<div formGroupName="monitored_fs_utilization" class="d-flex align-items-baseline pb-1 ml-4">
						<mat-checkbox
							class="mr-2"
							color="primary"
							formControlName="subscribed"
							(change)="toggleParent($event, FORM_CONTROL_IDS.zestyInfo, 'monitored_fs_utilization')"
						>
						</mat-checkbox>
						<div>
							<div class="line d-flex flex-wrap align-items-center pb-2">
								<span>Monitored FileSystem has reached utilization of</span>
								<input formControlName="threshold" class="form-control w100p ml-1 mr-2" type="number" />
								%
								<span
									*ngIf="
										getFormError(FORM_CONTROL_IDS.utilizationThreshold).hasError('max') ||
										getFormError(FORM_CONTROL_IDS.utilizationThreshold).hasError('min')
									"
									class="form__error"
								>
									should be between {{ THRESHOLD_CONFIG.monitoredFSSLow }} and
									{{ THRESHOLD_CONFIG.monitoredFSHigh }}
								</span>
								<span
									*ngIf="getFormError(FORM_CONTROL_IDS.utilizationThreshold)?.hasError('required')"
									class="form__error"
									>field is <strong>required</strong></span
								>
							</div>
							<div class="line d-flex flex-wrap align-items-center pb-2">
								<span>Reminder will be sent every</span>
								<input formControlName="snooze_hours" class="form-control w100p ml-1 mr-2" type="number" />
								<span>hours</span>
								<button
									class="info-icon-color"
									type="button"
									mat-icon-button
									appInfoTooltip="A notification will be sent once a monitored filesystem utilization reaches the configured threshold."
									aria-label="Example icon button with a vertical three dot icon"
								>
									<mat-icon>error</mat-icon>
								</button>
								<span
									*ngIf="
										getFormError(FORM_CONTROL_IDS.utilizationSnooze)?.hasError('max') ||
										getFormError(FORM_CONTROL_IDS.utilizationSnooze)?.hasError('min')
									"
									class="form__error"
									>should be between 0 and 744</span
								>
							</div>
						</div>
					</div>
					<!-- Zesty Disk FS size -->
					<div formGroupName="zesty_disk_fs_size" class="d-flex align-items-baseline pb-1 ml-4">
						<mat-checkbox
							class="mr-2"
							color="primary"
							formControlName="subscribed"
							(change)="toggleParent($event, FORM_CONTROL_IDS.zestyInfo, 'zesty_disk_fs_size')"
						>
						</mat-checkbox>
						<div>
							<div class="line d-flex flex-wrap align-items-center pb-2">
								<span>Zesty Disk File system is larger than</span>
								<input formControlName="threshold" class="form-control w100p ml-1 mr-2" type="number" />
								GB
								<div
									*ngIf="
										getFormError(FORM_CONTROL_IDS.diskSizeThreshold)?.hasError('max') ||
										getFormError(FORM_CONTROL_IDS.diskSizeThreshold)?.hasError('min')
									"
									class="form__error"
								>
									(should be between {{ THRESHOLD_CONFIG.zdFSLow }} and {{ THRESHOLD_CONFIG.zdFSHigh }})
								</div>
							</div>
							<div class="line d-flex flex-wrap align-items-center pb-2">
								<span>A reminder will be sent every </span>
								<input formControlName="snooze_hours" class="form-control w100p ml-1 mr-2" type="number" />
								<span>hours</span>
								<button
									class="info-icon-color"
									type="button"
									mat-icon-button
									appInfoTooltip="You will be notified once Zesty Disk file system has reached the size you configured."
									aria-label="Example icon button with a vertical three dot icon"
								>
									<mat-icon>error</mat-icon>
								</button>
								<span
									*ngIf="
										getFormError(FORM_CONTROL_IDS.diskSizeSnooze)?.hasError('max') ||
										getFormError(FORM_CONTROL_IDS.diskSizeSnooze)?.hasError('min')
									"
									class="form__error ml-1 mr-2"
									>(should be between 0 and 744)</span
								>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-expansion-panel>
			<!-- Unused Resources -->
			<mat-expansion-panel formGroupName="unused_resources" togglePosition="before">
				<mat-expansion-panel-header>
					<mat-panel-title>Unused Resources</mat-panel-title>
				</mat-expansion-panel-header>
				<!-- Info -->
				<mat-expansion-panel formGroupName="info" togglePosition="before">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<mat-checkbox
								formControlName="checked"
								color="primary"
								[indeterminate]="descendantsPartiallySelected(FORM_CONTROL_IDS.unusedResourcesInfo)"
								(change)="handleCheckSubForms($event, FORM_CONTROL_IDS.unusedResourcesInfo)"
								(click)="$event.stopPropagation()"
							>
								Info
							</mat-checkbox>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div formGroupName="unused_resources_policy_update" class="d-flex align-items-baseline ml-4 flex-wrap pb-3">
						<mat-checkbox
							class="mr-2"
							color="primary"
							formControlName="subscribed"
							(change)="toggleParent($event, FORM_CONTROL_IDS.unusedResourcesInfo)"
						>
							Policy Update
						</mat-checkbox>
						<button
							class="info-icon-color"
							type="button"
							mat-icon-button
							appInfoTooltip="You will be notified in an event that an unused resource policy was added, updated, or removed."
							aria-label="Example icon button with a vertical three dot icon"
						>
							<mat-icon>error</mat-icon>
						</button>
					</div>
					<div formGroupName="unused_resources_actions" class="ml60 pb-3 d-flex align-items-baseline ml-4 flex-wrap">
						<mat-checkbox
							class="mr-2"
							color="primary"
							formControlName="subscribed"
							(change)="toggleParent($event, FORM_CONTROL_IDS.unusedResourcesInfo)"
						>
							Unused Resources Events
						</mat-checkbox>
						<button
							class="info-icon-color"
							type="button"
							mat-icon-button
							appInfoTooltip="You will be notified if one of your unused resources has been archived or deleted."
							aria-label="Example icon button with a vertical three dot icon"
						>
							<mat-icon>error</mat-icon>
						</button>
					</div>
				</mat-expansion-panel>
			</mat-expansion-panel>
		</mat-expansion-panel>
		<!-- Targets -->
		<mat-expansion-panel formGroupName="targets" togglePosition="before">
			<mat-expansion-panel-header>
				<mat-panel-title>Targets</mat-panel-title>
			</mat-expansion-panel-header>
			<div formGroupName="teams" class="ml-4">
				<mat-checkbox color="primary" formControlName="subscribed">Teams</mat-checkbox>
			</div>
			<div *ngIf="hasSlack" formGroupName="slack" class="ml-4">
				<mat-checkbox color="primary" formControlName="subscribed">Slack</mat-checkbox>
				<ng-select
					*ngIf="slackSubscribed"
					[items]="slackChannels$ | async"
					[loading]="isLoading"
					[multiple]="true"
					loadingText="Fetching channels..."
					placeholder="Select channel"
					formControlName="channels"
				>
				</ng-select>
			</div>
			<div formGroupName="email" class="ml-4">
				<mat-checkbox color="primary" formControlName="subscribed">Emails</mat-checkbox>
				<div class="form-group">
					<mat-form-field class="w-100" appearance="outline">
						<mat-chip-list #chipList>
							<mat-chip
								selected
								*ngFor="let item of notificationSetFormEmails.value; let i = index"
								[selectable]="true"
								(removed)="removeEmail(i)"
							>
								{{ item }}
								<mat-icon matChipRemove>cancel</mat-icon>
							</mat-chip>
							<input
								placeholder="Add email"
								[matChipInputFor]="chipList"
								(matChipInputTokenEnd)="addEmail($event)"
								(input)="handleEmailChange($event)"
							/>
							<mat-error *ngIf="emailErrors">incorrect value or duplicate</mat-error>
						</mat-chip-list>
					</mat-form-field>
				</div>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</form>
